import Repository from '../axios'


export default {
  fetchObjectRecords(object_name, searchQuery = '') {
    return Repository.get(`/salesforce/get-records/${object_name}?search=${searchQuery}`)
  },
  getObjects() {
    return Repository.get('/salesforce/get-objects')
  },
  getObjectFiles(object_name) {
    return Repository.get(`/salesforce/get-object-files/${object_name}`)
  }
};
